import { ArrowDown, Sparkles } from "lucide-react";
import { assetUrl } from "@/lib/assets";

export default function HeroAbout() {
  return (
    <section id="heroabout" data-nav="dark" className="acad-about-hero">
      <img
        className="acad-about-hero-image"
        src={assetUrl("WhatsApp-Image-2026-08-21-at-9.10.10-AM.jpeg")}
        alt="Culto de adoración con creyentes levantando sus manos"
        loading="eager"
        decoding="async"
      />
      <span className="acad-about-hero-overlay" />
      <span className="acad-about-hero-grid" aria-hidden="true" />

      <div className="acad-about-shell acad-about-hero-inner">
        <div className="acad-about-hero-topline">
          <span><Sparkles aria-hidden="true" /> ACAD Costa Rica</span>
          <span>Una iglesia para cada comunidad</span>
        </div>

        <div className="acad-about-hero-copy">
          <span className="acad-about-eyebrow">Nuestra historia · Nuestra misión</span>
          <h1>
            Sobre las
            <span>Asambleas</span>
            <em>de Dios.</em>
          </h1>
          <p>
            Una comunidad pentecostal que existe para adorar, evangelizar,
            discipular creyentes y mostrar la compasión de Jesús.
          </p>
        </div>

        <div className="acad-about-hero-bottom">
          <a href="#historicaloverview">
            Descubrir nuestra historia <i><ArrowDown aria-hidden="true" /></i>
          </a>
          <span>Sirviendo a Costa Rica desde la década de 1940</span>
        </div>
      </div>

      <span className="acad-about-outline-word" aria-hidden="true">ACAD</span>
    </section>
  );
}
